import { css } from './Common'

export const clipBoard = (text) => {
	const textarea = document.createElement('textarea');

	css(textarea, {
		position: 'fixed',
		whiteSpace: 'pre-wrap',
		wordBreak: 'keep-all',
	});

	textarea.textContent = text;
	document.body.appendChild(textarea);
	textarea.select();

	try {
		return document.execCommand('copy'); // Security exception may be thrown by some browsers.
	} catch (ex) {
		console.warn('Copy to clipboard failed.', ex);
		return false;
	} finally {
		document.body.removeChild(textarea);
	}
};